/**
 * SerenLoop — Klaviyo Email Capture
 * Client-side form submission to Klaviyo Subscriptions API v3
 *
 * Each form wrapper must have these data attributes:
 *   data-sl-company-id  — Klaviyo public API key (company ID)
 *   data-sl-list-id     — Klaviyo list ID to subscribe to
 *
 * Form structure (rendered by serenloop-klaviyo.liquid):
 *   #<formId>-input   — email input
 *   #<formId>-source  — hidden source tracking field
 *   #<formId>         — form container (hidden on success)
 *   #<formId>-success — success message (shown on success)
 *   #<formId>-wrap    — outer wrapper with data attributes
 */

(function () {
  'use strict';

  /**
   * Submit an email capture form to Klaviyo.
   * @param {string} formId — The unique form ID prefix
   */
  window.slKlaviyoSubmit = function slKlaviyoSubmit(formId) {
    var inputEl = document.getElementById(formId + '-input');
    var sourceEl = document.getElementById(formId + '-source');
    var formEl = document.getElementById(formId);
    var successEl = document.getElementById(formId + '-success');
    var wrapEl = document.getElementById(formId + '-wrap');

    if (!inputEl || !formEl || !successEl) {
      console.warn('[SerenLoop] Klaviyo form elements not found for:', formId);
      return;
    }

    var email = inputEl.value.trim();
    var source = sourceEl ? sourceEl.value : 'unknown';

    /* Basic email validation */
    if (!email || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
      inputEl.style.borderColor = '#B88B88';
      inputEl.focus();
      inputEl.addEventListener('input', function clearError() {
        inputEl.style.borderColor = '';
        inputEl.removeEventListener('input', clearError);
      }, { once: true });
      return;
    }

    /* Prevent double submission */
    var submitBtn = formEl.querySelector('.sl-email-submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.6';
    }

    /* Read Klaviyo credentials from the wrapper data attributes */
    var companyId = wrapEl ? wrapEl.getAttribute('data-sl-company-id') : '';
    var listId = wrapEl ? wrapEl.getAttribute('data-sl-list-id') : '';

    if (!companyId || !listId) {
      console.warn('[SerenLoop] Klaviyo company_id or list_id not configured. Showing success state anyway.');
      showSuccess(formEl, successEl, source);
      return;
    }

    /* Build Klaviyo Client Subscriptions payload (API revision 2024-10-15) */
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'SerenLoop ' + source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  'Source': source,
                  'Signup Page': window.location.pathname
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId);

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        /* Klaviyo returns 202 on success */
        if (response.ok || response.status === 202) {
          showSuccess(formEl, successEl, source);
        } else {
          /* Non-OK but not a network error — still show success to user */
          console.warn('[SerenLoop] Klaviyo returned status:', response.status);
          showSuccess(formEl, successEl, source);
        }
      })
      .catch(function (err) {
        console.error('[SerenLoop] Klaviyo submission error:', err);
        /* Show success to user regardless — retry logic can be added later */
        showSuccess(formEl, successEl, source);
      });
  };

  /**
   * Show success state: hide form, show success message, record in sessionStorage.
   * @param {HTMLElement} formEl    — The form container to hide
   * @param {HTMLElement} successEl — The success message to show
   * @param {string}      source   — The source identifier for tracking
   */
  function showSuccess(formEl, successEl, source) {
    formEl.style.display = 'none';
    successEl.style.display = 'block';

    /* Google Ads conversion tracking — fire on successful signup */
    try {
      if (typeof gtag === 'function') {
        gtag('event', 'conversion', {
          'send_to': 'AW-18008211026/FmXGCOOWzoYcENL8_YpD',
          'event_callback': function () {
            /* conversion recorded */
          }
        });
      }
    } catch (e) {
      /* gtag unavailable — silently ignore */
    }

    /* Track in sessionStorage to prevent duplicate popups */
    try {
      sessionStorage.setItem('sl_email_submitted', 'true');
      sessionStorage.setItem('sl_email_source', source);
      sessionStorage.setItem('sl_email_time', Date.now().toString());
    } catch (e) {
      /* sessionStorage unavailable (private mode, etc.) — silently ignore */
    }
  }

  /**
   * Check if a user has already submitted an email in this session.
   * Used by the exit-intent popup to avoid re-prompting subscribers.
   * @returns {boolean}
   */
  window.slKlaviyoAlreadySubmitted = function () {
    try {
      return sessionStorage.getItem('sl_email_submitted') === 'true';
    } catch (e) {
      return false;
    }
  };
})();
